import { dealConstants } from "../constants/dealConstants";
import { dealService } from "../../services/API/dealService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";
import { categoryConst } from "../constants/categoryConst";
import { categoryService } from "../../services/API/categoryService";

export const dealActions = {
  getDealList,
  getDealPending,
  getDealUpcoming,
  getDealPast,
  deleteDeal,
  getDealDetail,
  getAllCategory,
  editDealList,
  addDealLocation,
  getDealCities,
  deleteImage,
  getOrderDeatil,
  confirmClose,
  uploadExternalVoucher,
  getOrderDeals,
  saveOrderDeal,
  getExternalVoucher,
  uploadImage,
  getDealSchedule,
  updateQuantity,
};

function getOrderDeals(formData) {
  return dispatch => {
    dealService.getOrderDeals(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(dealList) {
    return { type: dealConstants.GET_ORDER_DEALS_REQUEST, dealList };
  }
  function success(dealList) {
    return { type: dealConstants.GET_ORDER_DEALS_SUCCESS, dealList };
  }
  function failure(error) {
    return { type: dealConstants.GET_ORDER_DEALS_FAILURE, error };
  }
};

function saveOrderDeal(formData) {
  return dispatch => {
    dealService.saveOrderDeal(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.SAVE_ORDER_DEALS_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.SAVE_ORDER_DEALS_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.SAVE_ORDER_DEALS_FAILURE, error };
  }
};

export const editDealList = formData => {
  return dispatch => {
    dealService.editDealList(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.EDIT_DEALLIST_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.EDIT_DEALLIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.EDIT_DEALLIST_FAILURE, error };
  }
};

export const uploadImage = postData => {
  return dispatch => {
    dealService.uploadImage(postData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.UPLOAD_IMAGE_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.UPLOAD_IMAGE_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.UPLOAD_IMAGE_FAILURE, error };
  }
};

export const addDealLocation = (formdata, dealID) => {
  return dispatch => {
    dealService.addDealLocation(formdata, dealID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));

      }
    );
  };

  function request(data) {
    return { type: dealConstants.ADD_DEALLOC_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.ADD_DEALLOC_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.ADD_DEALLOC_FAILURE, error };
  }
};

export const getDealList = formData => {
  return dispatch => {
    dealService.getDealCurrent(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALCURRENT_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALCURRENT_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALCURRENT_FAILURE, error };
  }
};

export const getDealPending = formData => {
  return dispatch => {
    dealService.getDealPending(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALPENDING_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALPENDING_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALPENDING_FAILURE, error };
  }
};

export const getDealUpcoming = formData => {
  return dispatch => {
    dealService.getDealUpcoming(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALUPCOMING_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALUPCOMING_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALUPCOMING_FAILURE, error };
  }
};

export const getDealPast = formData => {
  return dispatch => {
    dealService.getDealPast(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALPAST_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALPAST_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALPAST_FAILURE, error };
  }
};


export const deleteDeal = dealID => {
  return dispatch => {
    dealService.deleteDeal(dealID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.DELETE_DEAL_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.DELETE_DEAL_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.DELETE_DEAL_FAILURE, error };
  }
};

export const deleteImage = id => {
  return dispatch => {
    dealService.deleteImage(id).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.DELETE_IMAGE_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.DELETE_IMAGE_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.DELETE_IMAGE_FAILURE, error };
  }
};

export const deleteDealLocation = (dealID, dealLocationID) => {
  return dispatch => {
    dispatch(request());
    dealService.deleteDealLocation(dealID, dealLocationID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.DELETE_DEAL_LOCATION_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.DELETE_DEAL_LOCATION_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.DELETE_DEAL_LOCATION_FAILURE, error };
  }
};

export const getDealDetail = (dealID, siteID) => {
  return dispatch => {
    dealService.getDealDetail(dealID, siteID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALDETAIL_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALDETAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALDETAIL_FAILURE, error };
  }
};

export const getAllCategory = formData => {
  return dispatch => {
    categoryService.getAllCategory(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(allcategory) {
    return { type: categoryConst.VIEW_ALL_CATEGORY_REQUEST, allcategory };
  }
  function success(allcategory) {
    return { type: categoryConst.VIEW_ALL_CATEGORY_SUCCESS, allcategory };
  }
  function failure(error) {
    return { type: categoryConst.VIEW_ALL_CATEGORY_FAILURE, error };
  }
};

export const getOrderDeatil = (dealID, siteID) => {
  return dispatch => {
    dealService.getOrderDeatil(dealID, siteID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALORDER_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALORDER_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALORDER_FAILURE, error };
  }
}
export const getDealCities = () => {
  return dispatch => {
    dealService.getDealCities().then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALCITIES_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALCITIES_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALCITIES_FAILURE, error };
  }
};

export const confirmClose = formData => {
  return dispatch => {
    dealService.confirmClose(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.CONFIRM_CLOSE_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.CONFIRM_CLOSE_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.CONFIRM_CLOSE_FAILURE, error };
  }
};
export const uploadExternalVoucher = formData => {
  return dispatch => {
    dealService.uploadExternalVoucher(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.POST_EXTERNAL_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.POST_EXTERNAL_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.POST_EXTERNAL_FAILURE, error };
  }
};
export const getExternalVoucher = formData => {
  return dispatch => {
    dealService.getExternalVoucher(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.POST_UPEXTERNAL_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.POST_UPEXTERNAL_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.POST_UPEXTERNAL_FAILURE, error };
  }
};

export const getDealSchedule = formData => {
  return dispatch => {
    dealService.getDealSchedule(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALSCHEDULE_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALSCHEDULE_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALSCHEDULE_FAILURE, error };
  }
};

export const updateAttribute = formData => {
  return dispatch => {
    dealService.updateAttribute(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.POST_ATTRIBUTE_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.POST_ATTRIBUTE_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.POST_ATTRIBUTE_FAILURE, error };
  }
};

export const updateQuantity = formData => {
  return dispatch => {
    dealService.updateQuantity(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.UPDATE_QUANTITY_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.UPDATE_QUANTITY_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.UPDATE_QUANTITY_FAILURE, error };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/actions/dealActions.js